module.exports = {
      id: "gzsports-usage",
      viewBox: "0 0 17.95 23.898",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#gzsports",
      toString: function () {
        return this.url;
      }
    }